import React from 'react';
import { i18n } from 'config/locales';
import { Summary, DateSummary } from 'components/Summary';

import { LEGAL, LEGAL_TECHNOLOGY_NONCOMPLIANCE } from 'config/formSections/legal';
import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import { EmptyListInstance } from 'forms/shared/models';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import NonComplianceItem from './NonComplianceItem';
import { isPVQForm } from 'helpers/form';
import { formConfig } from 'config/forms';
import { getNumberOfYearsString } from 'helpers/text';


const sectionConfig = {
  key: LEGAL_TECHNOLOGY_NONCOMPLIANCE.key,
  section: LEGAL.name,
  store: LEGAL.store,
  subsection: LEGAL_TECHNOLOGY_NONCOMPLIANCE.name,
  storeKey: LEGAL_TECHNOLOGY_NONCOMPLIANCE.storeKey,
};

export class NonCompliance extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.updateBranch = this.updateBranch.bind(this);
    this.updateList = this.updateList.bind(this);
    this.summary = this.summary.bind(this);
  }

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      List: this.props.List,
      HasNonCompliance: this.props.HasNonCompliance,
      ...queue,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateBranch = (values) => {
    this.update({
      HasNonCompliance: values,
      List: values.value === 'Yes' ? this.props.List : [],
    });
  };

  summary = (item, index) => {
    const o = (item && item.Item) || {};
    const dates = DateSummary(o.Date);
    const incident = (o.Incident || {}).value ? o.Incident.value : '';

    return Summary({
      type: i18n.t('legal.pvq.protectedInformation.subsection.noncompliance.collection.item'),
      index,
      left: incident,
      right: dates,
      placeholder: i18n.t('legal.pvq.protectedInformation.subsection.noncompliance.collection.unknown'),
    });
  };

  render() {
    const { formType, errors } = this.props;
    const accordionErrors = errors && errors.filter((e) => e.indexOf('List.accordion') === 0);
    const formTypeConfig = formType && formConfig[formType];
    const isPVQ = isPVQForm(formType);
    const years = formTypeConfig && formTypeConfig.LEGAL_TECHNOLOGY_NONCOMPLIANCE_USE_YEARS;



    return isPVQ ? (
      <div
        className="section-content legal-technology-noncompliance"
        data-section={LEGAL.key}
        data-subsection={LEGAL_TECHNOLOGY_NONCOMPLIANCE.key}
      >
        <h1 className="section-header">{i18n.t('legal.pvq.protectedInformation.subsection.noncompliance.pageTitle')}</h1>

        <Branch
          {...this.props.HasNonCompliance}
          name="has_noncompliance"
          label={i18n.t('legal.pvq.protectedInformation.subsection.noncompliance.title')}
          labelSize="h4"
          className="legal-technology-protected-inforamtion-has-noncompliance"
          warning
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          required={this.props.required}
          onUpdate={this.updateBranch} // eslint-disable-line @typescript-eslint/unbound-method
          scrollIntoView={this.props.scrollIntoView}
          attribute="HasNonCompliance"
        />

        <Show when={this.props.HasNonCompliance.value === 'Yes'}>
          <Accordion
            {...this.props.List}
            defaultState={this.props.defaultState}
            scrollToBottom={this.props.scrollToBottom}
            summary={this.summary} // eslint-disable-line @typescript-eslint/unbound-method
            onUpdate={this.updateList} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            errors={accordionErrors}
            description={i18n.t('legal.pvq.protectedInformation.subsection.noncompliance.collection.description')}
            appendTitle={i18n.t('legal.pvq.protectedInformation.subsection.noncompliance.collection.appendTitle')}
            appendLabel={i18n.t('legal.pvq.protectedInformation.subsection.noncompliance.collection.appendLabel')}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            attribute="List"
          >
            <NonComplianceItem
              name="Item"
              bind
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              addressBooks={this.props.addressBooks}
              dispatch={this.props.dispatch}
              formType={formType}
              attribute="List"
            />
          </Accordion>
        </Show>
      </div>
    ) : (
      <>{/*NA, PVQ Only */}</>
    );
  }
}

NonCompliance.defaultProps = {
  name: 'NonCompliance',
  HasNonCompliance: {},
  List: EmptyListInstance,
  defaultState: true,
  onUpdate: () => { },
  onError: (value, arr) => arr,
  section: 'legal',
  subsection: 'technology/noncompliance',
  addressBooks: {},
  dispatch: () => { },
  scrollToBottom: '',
  errors: [],
};

export default connectSubsection(NonCompliance, sectionConfig);
